import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { CONSTANTS, Constants, User } from 'lib-trend-core'
import { LanguageService } from './i18n/language.service'

@Component({
    selector: 'app-root',
    template: `
    <alert></alert>
    <router-outlet></router-outlet>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(
    private readonly languageService: LanguageService,
    @Inject(CONSTANTS) private readonly constants: Constants,
  ) { }

  ngOnInit(): void {
    // Resolve the effective language at startup: stored choice → logged user
    // preference → company default → pt-BR. Applies translations without reload.
    let user: User | undefined
    try {
      const raw = localStorage.getItem(this.constants['currentUser'])
      user = raw ? JSON.parse(raw)?.user : undefined
    } catch {
      user = undefined
    }
    this.languageService.initFromUser(user)
  }
}
